<template>
  <v-card>
    <v-card-title>
      <div class="headline">General</div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6 v-if="!newBusCls">
            <v-subheader class="queryLabel">{{labels.busClsQuery}}</v-subheader>
            <div class="title">{{busClsForm.busCls}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-text-field :label="labels.busCls" v-model="busClsForm.busCls" :error-messages="errors.collect('busCls')" v-validate="'required|param|max:4'" data-vv-name="busCls" :data-vv-as="labels.busCls"></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field :label="labels.desc" v-model="busClsForm.desc" :error-messages="errors.collect('desc')" v-validate="'required|entry|max:60'" data-vv-name="desc" :data-vv-as="labels.desc"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="isMatchRoute('motorBusClsGeneral')">
            <v-autocomplete :label="labels.vehGrp" v-model="busClsForm.vehGrp" :items="vehGrpList" item-text="label" item-value="value" data-vv-name="vehGrp" :data-vv-as="labels.vehGrp" :error-messages="errors.collect('vehGrp')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :label="labels.busClsAppId" v-model="busClsForm.busClsAppId" :items="appIdList" item-text="label" item-value="value" data-vv-name="busClsAppId" :data-vv-as="labels.busClsAppId" :error-messages="errors.collect('busClsAppId')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.perGst" v-model="busClsForm.perGst"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-if="!isMatchRoute('motorBusClsGeneral') || isMatchRoute('packageBusClsGeneral')">
            <!-- space -->
          </v-flex>
          <v-flex xs6 v-if="isMatchRoute('motorBusClsGeneral') || isMatchRoute('cargoBusClsGeneral')">
            <v-autocomplete v-model="selectedTariff" :label="labels.tariff" multiple chips :items="tariffList" item-text="label" item-value="value" return-object item-disabled="disabled" data-vv-name="tariff" :data-vv-as="labels.tariff" :error-messages="errors.collect('tariff')" v-validate="'required'">
              <template slot="selection" slot-scope="data">
                <v-chip v-bind:close="closeChip(data)" @input="data.parent.selectItem(data.item.value)" :selected="data.selected" deletable-chips class="chip--select-multi" :key="JSON.stringify(data.item.value)" >
                  {{ data.item.label }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs6 v-if="isMatchRoute('motorBusClsGeneral') || isMatchRoute('cargoBusClsGeneral')">
            <v-autocomplete v-model="selectedCovers" :label="labels.covers" multiple chips :items="coverList" item-text="label" item-value="value" return-object item-disabled="disabled" data-vv-name="covers" :data-vv-as="labels.covers" :error-messages="errors.collect('covers')" v-validate="'required'">
              <template slot="selection" slot-scope="data">
                <v-chip v-bind:close="closeChip(data)" @input="data.parent.selectItem(data.item.value)" :selected="data.selected" class="chip--select-multi" :key="JSON.stringify(data.item.value)">
                  {{ data.item.label }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs6 v-if="isMatchRoute('motorBusClsGeneral') || isMatchRoute('cargoBusClsGeneral')">
            <v-autocomplete :hint="labels.tariffHint" :persistent-hint="tariffList > 0 ? false : true" :label="labels.defTariff" v-model="busClsForm.defTariff" :items="selectedTariff" item-text="label" item-value="value" data-vv-name="defTariff" :data-vv-as="labels.defTariff" :error-messages="errors.collect('defTariff')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6 v-if="!(isMatchRoute('motorBusClsGeneral') || isMatchRoute('cargoBusClsGeneral'))">
            <v-autocomplete :label="labels.defTariff" v-model="busClsForm.defTariff" :items="tariffList" item-text="label" item-value="value" data-vv-name="defTariff" :data-vv-as="labels.defTariff" :error-messages="errors.collect('defTariff')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex lg12 md12 xs12>
            <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
                {{  newBusCls ? 'Save Business Class' : 'Update Business Class' }}
              <v-icon right>{{newBusCls ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import routeMixin from '@/mixins/route'
import { appID, busClsAppID } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        busCls: 'Business Class Code*',
        busClsQuery: 'Business Class Code',
        desc: 'Business Class Description*',
        tariff: 'Tariff*',
        defTariff: 'Default Tariff*',
        covers: 'Coverages*',
        vehGrp: 'Vehicle Group*',
        perGst: 'Permitted GST',
        tariffHint: 'Please selected Tariff first',
        busClsAppId: 'App ID'
      },
      busClsForm: {
        busCls: null,
        desc: null,
        defTariff: null,
        perGst: false,
        perStp: false,
        perTonnage: false,
        vehGrp: null,
        busClsAppId: null
      },
      vehGrpList: [],
      tariffList: [],
      coverList: [],
      selectedTariff: [],
      selectedCovers: [],
      appIdList: [],
      menu: [],
      submitting: false,
      newBusCls: false
    }
  },
  computed: {
    appId() {
      return this.$store.state.parameters.appID
    },
    busClsMenu() {
      return this.$store.state.parameters.busCls
    }
  },
  methods: {
    closeChip(data) {
      if (data.item.disabled) {
        return false
      } else {
        return true
      }
    },
    async doInit() {
      const apiURI = this.busClsMenu.menu.busClsGet
      if (apiURI) {
        const expand = {
          busCls: this.id
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          this.tariffList = result.data.data.tariffList
          this.coverList = result.data.data.coverList
          this.vehGrpList = result.data.data.vehGrpList
          this.selectedTariff = result.data.data.busClsTarfList
          this.selectedCovers = result.data.data.busClsCoverList
          this.appIdList = result.data.data.appIdList
          if (data) {
            this.busClsForm.busCls = data.busCls.busCls
            this.busClsForm.desc = data.busCls.desc
            this.busClsForm.defTariff = data.busCls.defTariff
            this.busClsForm.perGst = data.busCls.perGst
            this.busClsForm.perStp = data.busCls.perStp
            this.busClsForm.perTonnage = data.busCls.perTonnage
            this.busClsForm.vehGrp = data.busCls.vehGrp
            this.busClsForm.busClsAppId = data.busCls.busClsAppId

            this.menu = extractMenu(result.data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Review Business Class')
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      const convertTariff = this.selectedTariff.map(function (item) {
        return item.value
      })
      if (this.appId === appID.MOTOR || this.appId === appID.CARGO) {
        if (!convertTariff.includes(this.busClsForm.defTariff)) {
          this.busClsForm.defTariff = null
        }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newBusCls) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.busClsMenu.menu.busClsCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.busClsForm)
          const { data } = result

          if (data) {
            const saveTariffResult = await this.busClsTariffSave()
            const saveCoverResult = await this.busClsCoverSave()
            if (saveTariffResult) {
              if (saveCoverResult) {
                // Show message via notify
                this.notify(data)
                // Return to list
                this.newBusCls = false
                switch (this.appId) {
                  case appID.MOTOR: {
                    this.$router.push({ name: 'motorBusClsList' })
                    break
                  }
                  case appID.TRAVEL: {
                    this.$router.push({ name: 'travelBusClsList' })
                    break
                  }
                  case appID.FIRE: {
                    this.$router.push({ name: 'fireBusClsList' })
                    break
                  }
                  case appID.CARGO: {
                    this.$router.push({ name: 'cargoBusClsList' })
                    break
                  }
                  case appID.MAID: {
                    this.$router.push({ name: 'maidBusClsList' })
                    break
                  }
                  case appID.PACKAGE: {
                    this.$router.push({ name: 'packageBusClsList' })
                    break
                  }
                  default: {
                    this.$router.push({ name: 'packageBusClsList' })
                  }
                }
              } else {
                await this.doRemove()
              }
            } else {
              await this.doRemove()
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Create')
      }
    },
    async doUpdate() {
      const apiURI = this.menu.busClsUpdate
      await this.busClsCoverSave()
      await this.busClsTariffSave()
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.busClsForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.newBusCls = false
            this.$emit('resetSideMenu')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Update')
      }
    },
    doClearBusClsForm() {
      this.resetValidator()
      this.resetMessages()
      this.busClsForm.busCls = null
      this.busClsForm.desc = null
      this.busClsForm.defTariff = null
      this.busClsForm.perGst = false
      this.busClsForm.perStp = false
      this.busClsForm.perTonnage = false
      this.busClsForm.vehGrp = null
      this.busClsForm.busClsAppId = null
    },
    async tariffListInit() {
      const apiURI = this.busClsMenu.menu.tariffList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.tariffList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Tariff List')
      }
    },
    async coverListInit() {
      const apiURI = this.busClsMenu.menu.coverList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.coverList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Coverage List')
      }
    },
    async vehGrpListInit() {
      const apiURI = this.busClsMenu.menu.vehGrpList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.vehGrpList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Vehicle Group List')
      }
    },
    async busClsTariffSave() {
      const apiURI = this.busClsMenu.menu.busClsTariffListCreate
      if (apiURI) {
        const convertArray = this.selectedTariff.map(function (item) {
          return item.value
        })
        const expand = {
          busCls: this.busClsForm.busCls,
          tariffList: convertArray
        }
        try {
          const result = await this.$http.post(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            return true
          } else {
            return false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async busClsCoverSave() {
      const apiURI = this.busClsMenu.menu.busClsCoverListCreate
      if (apiURI) {
        const convertArray = this.selectedCovers.map(function (item) {
          return item.value
        })
        const expand = {
          busCls: this.busClsForm.busCls,
          coverList: convertArray
        }
        try {
          const result = await this.$http.post(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            return true
          } else {
            return false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doRemove() {
      const apiURI = this.busClsMenu.menu.busClsDelete
      if (apiURI) {
        const expand = {
          busCls: this.busClsForm.busCls
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          if (result) {
            this.errorMessage('Fail to create business class')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.errorMessage('Fail to delete business class')
          }
        }
      } else {
        this.errorMessage('Fail to delete business class')
      }
    },
    busClsAppList() {
      const list = Object.freeze(busClsAppID)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    }
  },
  mounted() {
    if (this.id === 'new') {
      this.newBusCls = true
      this.appIdList = this.busClsAppList()
      Promise.all([this.tariffListInit(), this.coverListInit(), this.vehGrpListInit()])
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin,
    routeMixin
  ],
  props: {
    id: String
  }
}
</script>

<style>

</style>
